import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Input, Select, Table } from "antd";
import { bookServiceDefault, BookService } from "./types";
import { t } from "@lingui/macro";
import { useFormik } from "formik";
import {
	getListStaffAsync,
	selectStaffList,
} from "features/staff/redux/staff.slice";
import TextArea from "antd/lib/input/TextArea";
import { SaveOutlined, LeftOutlined } from "@ant-design/icons";
import { translate } from "utils";

const { Option } = Select;

export default function BookServiceDetail() {
	const staffList = useSelector(selectStaffList);
	const dispatch = useDispatch();

	useEffect(() => {
		if (staffList.length === 0) {
			dispatch(
				getListStaffAsync({
					query: {
						fullName: null,
						phoneNumber: null,
						email: null,
						skip: 0,
						take: 10,
						status: null,
						role: null,
					},
				}),
			);
		}
	}, [dispatch, staffList.length]);

	const { id } = useParams();

	const formik = useFormik({
		initialValues: bookServiceDefault,
		validateOnBlur: false,
		validateOnChange: false,
		onSubmit(values: BookService) {
			// handle onSubmit
			if (id) {
				// handle ...
			} else {
				// handle
			}
		},
	});

	const { values, handleSubmit, handleChange, validateField } = formik;

	const bookingCarColumns = [
		{
			title: "Image",
			dataIndex: "image",
			key: "image",
		},
		{
			title: "Title",
			dataIndex: "title",
			key: "title",
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
		},
		{
			title: "Note",
			dataIndex: "note",
			key: "note",
		},
	];

	const bookingCarsSource = [
		{
			image: "Common",
			title: "Toyota Innova 2020",
			status: "Publish",
			note: "Loremp ipsum",
		},
		{
			image: "Common",
			title: "Toyota Innova 2020",
			status: "Publish",
			note: "Loremp ipsum",
		},
		{
			image: "Common",
			title: "Toyota Innova 2020",
			status: "Publish",
			note: "Loremp ipsum",
		},
	];

	const listServicesColumns = [
		{
			title: "Service Name",
			dataIndex: "serviceName",
			key: "serviceName",
		},
		{
			title: "Price",
			dataIndex: "price",
			key: "price",
		},
		{
			title: "Note",
			dataIndex: "note",
			key: "note",
		},
	];

	const listServicesSource = [
		{
			serviceName: "Insurance",
			price: "$500",
			note: "Loremp ipsum",
			action: "",
		},
		{
			serviceName: "Insurance",
			price: "$500",
			note: "Loremp ipsum",
			action: "",
		},
		{
			serviceName: "Insurance",
			price: "$500",
			note: "Loremp ipsum",
			action: "",
		},
	];

	return (
		<div className="bg-white p-5 h-full my-5 fade-in">
			<form
				autoComplete="off"
				onSubmit={handleSubmit}
				className="mt-4 info-form"
			>
				<div className="flex flex-row content-center">
					<label htmlFor="updateStatus">{t`Update status`}</label>
					&nbsp; &nbsp;
					<Button
						type="primary"
						className="rounded-md bg-[#fbbf24] border-[#fbbf24] hover:bg-[#f59e0b] hover:border-[#f59e0b]"
						size="small"
					>
						Processing
					</Button>
					&nbsp; &nbsp;
					<Button
						type="primary"
						className="rounded-md text-slate-400 border-slate-400"
						size="small"
					>{t`Cancel`}</Button>
				</div>
				<br />
				<div className="grid grid-cols-2 md:gap-x-4 lg:gap-x-12">
					<div>
						<label htmlFor="transactionId">{t`Transaction ID`}</label>
						<br />
						<Input
							placeholder={t`Transaction ID`}
							name="transactionId"
							id="transactionId"
							value={values.id || ""}
							onChange={handleChange}
							onBlur={() => validateField("id")}
							className="w-full"
						/>
					</div>
					<div>
						<label htmlFor="customer">{t`Customer`}</label>
						<br />
						<Input
							placeholder={t`Customer`}
							name="customer"
							id="customer"
							value={values.customer || ""}
							onChange={handleChange}
							onBlur={() => validateField("customer")}
							className="w-full"
						/>
					</div>
				</div>
				<br />
				<div className="grid grid-cols-2 md:gap-x-4 lg:gap-x-12">
					<div>
						<label htmlFor="testtime">{t`Status`}</label>
						<Select
							id="t"
							placeholder={t`Draft`}
							className="w-full"
							value={"Canceled"}
						>
							<Option value={0}>{t`Draft`}</Option>
							<Option value={1}>{t`Processing`}</Option>
							<Option value={2}>{t`Canceled`}</Option>
							<Option value={3}>{t`Completed`}</Option>
						</Select>
					</div>
					<div>
						<label htmlFor="testtime">{t`Staff`}</label>
						<Select
							id="t"
							className="w-full"
							value={staffList[0]?.fullName || "hehe"}
						>
							{staffList.map((option, index) => (
								<Option key={index} value={option.fullName}>
									{option.fullName}
								</Option>
							))}
						</Select>
					</div>
				</div>
				<br />
				<div className="flex flex-row space-x-8 mt-4 md:mt-0">
					<div className="grow">
						<label htmlFor="note">{t`Note`}</label>
						<br />
						<TextArea
							placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing..."
							autoSize={{ minRows: 2, maxRows: 5 }}
						/>
					</div>
				</div>
			</form>
			<br />
			<div className="flex flex-row">
				<p className="text-base font-semibold">Booking Cars Informations</p>
			</div>

			<Table
				bordered
				scroll={{ x: 1000 }}
				dataSource={bookingCarsSource}
				columns={bookingCarColumns}
			/>

			<div className="flex flex-row">
				<p className="text-base font-semibold">List Service Informations</p>
			</div>
			<Table
				bordered
				scroll={{ x: 1000 }}
				dataSource={listServicesSource}
				columns={listServicesColumns}
			/>

			<div className="mt-10 flex justify-center sm:justify-end items-center">
				<Link to="/transaction-service">
					<Button
						icon={<LeftOutlined />}
						type="primary"
						className="flex items-center bg-[#595959] focus:bg-[#8c8c8c] active:bg-[#8c8c8c] hover:bg-[#8c8c8c] border-0"
					>
						{translate("Go back")}
					</Button>
				</Link>
				<Button
					htmlType="submit"
					icon={<SaveOutlined />}
					type="primary"
					className="flex items-center bg-[#1890ff] mr-2"
				>
					{translate("Save")}
				</Button>
			</div>
		</div>
	);
}
